import { render } from "./SearchBox.vue?vue&type=template&id=8baa586e"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"
script.render = render

export default script